// Стек «Назад»: всё, что открыто поверх экрана (карточка, окно, лист, всплывашка),
// встаёт сюда. «Назад» Telegram и Esc закрывают верхнее. Без DOM и React —
// проверяется в backStack.test.ts; кнопкой Telegram управляет useBack.ts.

export type BackHandler = () => void

interface Entry {
  id: number
  handler: BackHandler
}

export interface BackStack {
  nextId(): number
  /** Встать наверх. Тот же id второй раз — без дубля, на прежнем месте. */
  push(id: number, handler: BackHandler): void
  remove(id: number): void
  size(): number
  topId(): number | null
  /** Слой сверху? 0 — сам экран: сверху ничего не открыто. */
  isTop(layer: number): boolean
  /** Закрыть верхнее. false — стек пуст, «Назад» уходит экрану. */
  back(): boolean
  subscribe(cb: () => void): () => void
}

export function createBackStack(): BackStack {
  let entries: Entry[] = []
  let seq = 0
  const listeners = new Set<() => void>()
  const emit = () => listeners.forEach((cb) => cb())

  return {
    nextId: () => (seq += 1),
    push(id, handler) {
      const found = entries.find((e) => e.id === id)
      if (found) {
        found.handler = handler
        return
      }
      entries = [...entries, { id, handler }]
      emit()
    },
    remove(id) {
      const next = entries.filter((e) => e.id !== id)
      if (next.length === entries.length) return
      entries = next
      emit()
    },
    size: () => entries.length,
    topId: () => entries[entries.length - 1]?.id ?? null,
    isTop(layer) {
      if (layer === 0) return entries.length === 0
      return entries[entries.length - 1]?.id === layer
    },
    back() {
      const top = entries[entries.length - 1]
      if (!top) return false
      top.handler()
      return true
    },
    subscribe(cb) {
      listeners.add(cb)
      return () => {
        listeners.delete(cb)
      }
    },
  }
}

/** Один стек на приложение. */
export const backStack = createBackStack()
